import Comparison from '@/shared/enums/ComparisonOperator';
import FilterType from '@/shared/enums/FilterType';
import operatorMap from './operatorMap';

export const BooleanComparator = new Map([
  [Comparison.IS, operatorMap.get(Comparison.IS)],
]);

export const ExistsComparator = new Map([
  [Comparison.EXISTS, operatorMap.get(Comparison.EXISTS)],
]);

export const DateComparator = new Map([
  [Comparison.AFTER, operatorMap.get(Comparison.AFTER)],
  [Comparison.BEFORE, operatorMap.get(Comparison.BEFORE)],
]);

// Multi select comparison.
export const MultiSelectComparator = new Map([
  [Comparison.INCLUDE_ANY, operatorMap.get(Comparison.INCLUDE_ANY)],
  [Comparison.INCLUDE_ALL, operatorMap.get(Comparison.INCLUDE_ALL)],
  [Comparison.EXCLUDE_ANY, operatorMap.get(Comparison.EXCLUDE_ANY)],
  [Comparison.EXCLUDE_ALL, operatorMap.get(Comparison.EXCLUDE_ALL)],
]);

// Number comparisons.
export const NumberComparator = new Map([
  [Comparison.LESS_THAN, operatorMap.get(Comparison.LESS_THAN)],
  [
    Comparison.LESS_THAN_OR_EQUAL,
    operatorMap.get(Comparison.LESS_THAN_OR_EQUAL),
  ],
  [Comparison.EQUALS, operatorMap.get(Comparison.EQUALS)],
  [
    Comparison.GREATER_THAN_OR_EQUAL,
    operatorMap.get(Comparison.GREATER_THAN_OR_EQUAL),
  ],
  [Comparison.GREATER_THAN, operatorMap.get(Comparison.GREATER_THAN)],
]);

// Single select comparison.
export const SelectComparator = new Map([
  [Comparison.INCLUDE_ALL, operatorMap.get(Comparison.INCLUDE_ALL)],
]);

// Text comparisons.
export const TextComparator = new Map([
  [Comparison.STARTS_WITH, operatorMap.get(Comparison.STARTS_WITH)],
  [Comparison.CONTAINS, operatorMap.get(Comparison.CONTAINS)],
  [Comparison.NOT_CONTAINS, operatorMap.get(Comparison.NOT_CONTAINS)],
]);

// Mapping allowable comparison types to their filter type.
const ComparatorMap = new Map([
  [FilterType.BOOLEAN, BooleanComparator],
  [FilterType.EXISTS, ExistsComparator],
  [FilterType.DATE, DateComparator],
  [FilterType.MULTI_SELECT, MultiSelectComparator],
  [FilterType.NUMBER, NumberComparator],
  [FilterType.SELECT, SelectComparator],
  [FilterType.TEXT, TextComparator],
]);

export default ComparatorMap;
